import React, { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { SelectField } from 'components/shared/input'
import { A4 } from 'components/shared/print'
import { setPageSize, toDateText } from 'utils/util'
import styled from 'styled-components'
import _ from 'lodash'
import { ReagentItem, ReagentItemSearchForm } from 'entities/reagent_item'
import { useFetchReagentsApi } from 'api/reagent'
import { useFetchReagentItemsApi } from 'api/reagent_item'
import { Reagent } from 'entities/reagent'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import { LedgerFooter, LedgerHeader } from '../ledger_componet'

type Props = {
    history: H.History
}

const Th = styled.th`
    border: solid 1px black;
    padding: 5px;
    text-align: center;
`

const Td = styled.td`
    border: solid 1px black;
    padding: 10px 5px;
    text-align: center;
`

const ReagentLedgerPage = ({ history }: Props) => {
    const globalState = useContext(GlobalStateContext)
    // const initDate = { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().endOf('month').format('YYYY-MM-DD') }
    // const periodForm = useForm<{ year: string; month: string }>({
    //     year: moment().format('YYYY'),
    //     month: moment().format('MM'),
    // })
    const selectReagentForm = useForm<{ reagentId?: number }>({})

    const reagentsApi = useFetchReagentsApi()

    const searchForm = useForm<ReagentItemSearchForm>({
        reagentId: String(selectReagentForm.object.reagentId),
        ordering: 'reagent_item_box_number',
    })
    const reagentItemsApi = useFetchReagentItemsApi(searchForm)

    useEffect(() => {
        reagentsApi.execute()
        setPageSize('landscape')
    }, [])

    useEffectSkipFirst(() => {
        searchForm.update((f) => {
            f.reagentId = String(selectReagentForm.object.reagentId)
        })
    }, [selectReagentForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(reagentItemsApi.loading)
    }, [reagentItemsApi.loading])

    const getCurrentReagent = (): Reagent | undefined => {
        return reagentsApi.response.results.find((r) => r.id === selectReagentForm.object.reagentId)
    }

    // useEffectSkipFirst(() => {
    //     searchForm.update((f) => {
    //         f.disposedDateAfter = moment(`${periodForm.object.year}-${periodForm.object.month}-01`).startOf('month').format('YYYY-MM-DD')
    //         f.disposedDateBefore = moment(`${periodForm.object.year}-${periodForm.object.month}-01`).endOf('month').format('YYYY-MM-DD')
    //     })
    // }, [periodForm.object])

    const chunks = (): ReagentItem[][] => {
        return _.chunk(reagentItemsApi.response.results, 8)
    }
    return (
        <>
            <div className="no-print" style={{ margin: 20 }}>
                <Flex>
                    {/* <div style={{ marginRight: 10, width: 250 }}>
                        <SelectField className="" form={periodForm} attr="year" selectItems={selectYears()} />
                    </div>
                    <div style={{ width: 150 }}>
                        <SelectField
                            className=""
                            form={periodForm}
                            attr="month"
                            selectItems={Array(12)
                                .fill(0)
                                .map((_, m) => ({ label: `${m + 1}月`, value: ('0' + (m + 1)).slice(-2) }))}
                        />
                    </div> */}
                    <SelectField
                        form={selectReagentForm}
                        attr={'reagentId'}
                        label="試薬選択"
                        includeBlank
                        selectItems={reagentsApi.response.results.map((r) => {
                            return { label: r.name, value: r.id! }
                        })}
                    />
                </Flex>
                <div>
                    <Button
                        disabled={!selectReagentForm.object.reagentId}
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </div>
            {selectReagentForm.object.reagentId &&
                chunks().map((chunk, cidx) => {
                    return (
                        <A4 landscape padding={0} key={'chunk-' + cidx}>
                            <div>
                                <div style={{ padding: '30px 60px' }}>
                                    <LedgerHeader
                                        headerTitle="試薬管理台帳"
                                        recordTypeNum="RCL00004"
                                        originalDocument="LSOP-RCL004"
                                        versionNum="2"
                                        timestamp={moment().format('YYYYMMDDHHmm')}
                                    ></LedgerHeader>

                                    <Flex justifyContent="flex-end" alignItems="center" style={{ textAlign: 'center', margin: '20px 0', fontSize: 18 }}>
                                        <div style={{ width: 150 }}>保存温度: {getCurrentReagent()?.preservation}</div>
                                        <Flex style={{ borderBottom: '2px solid #000' }}>
                                            <div style={{ width: 150, fontWeight: 'bold' }}>試薬名</div>
                                            <div style={{ width: 400, textAlign: 'left' }}>{getCurrentReagent()?.name}</div>
                                        </Flex>
                                    </Flex>
                                    <div style={{ fontSize: 12 }}>
                                        <table style={{ border: 'solid 2px black', width: '100%' }}>
                                            <thead>
                                                <Th style={{ width: 120 }}>納品日</Th>
                                                <Th style={{ width: 60 }}>箱No</Th>
                                                <Th style={{ textAlign: 'center', width: 90 }}>ロットNo</Th>
                                                <Th style={{ width: 120 }}>製造年月日</Th>
                                                <Th style={{ width: 120 }}>有効期限</Th>
                                                <Th style={{ width: 120 }}>使用開始日</Th>
                                                <Th style={{ width: 120 }}>使用者</Th>
                                                <Th style={{ verticalAlign: 'middle', textAlign: 'left' }}>備考</Th>
                                            </thead>
                                            <tbody>
                                                {chunk.map((item, index) => {
                                                    return (
                                                        <tr key={'disposal-ledger' + index}>
                                                            <Td style={{ padding: '0 5px', verticalAlign: 'middle' }}>{toDateText(item.deliveredDate)}</Td>
                                                            <Td>{item.boxNumber}</Td>
                                                            <Td style={{ textAlign: 'center' }}>{item.lot}</Td>
                                                            <Td>{toDateText(item.manufacturedDate)}</Td>
                                                            <Td>{toDateText(item.expiredDate)}</Td>
                                                            <Td>{toDateText(item.openedDate)}</Td>
                                                            <Td>{item.openedUser?.fullName}</Td>
                                                            <Td style={{ padding: '0 5px', verticalAlign: 'middle', textAlign: 'left' }}>{item.note}</Td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <LedgerFooter page={cidx + 1}></LedgerFooter>
                            </div>
                        </A4>
                    )
                })}
        </>
    )
}

export default withRouter(ReagentLedgerPage)
